import { FC, useCallback, useEffect, useState } from 'react';
import PrintIcon from '@mui/icons-material/Print';
import { Button, CircularProgress } from '@mui/material';
import cn from 'classnames';

import { IPrintButtonProps, TPrintButtonAction } from './PrintButton.interface';

import './style.scss';

const PrintButton: FC<IPrintButtonProps> = ({
  className,
  buttonText,
  linkToPrintPage,
  onClick,
  disableIframe = false,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleMessage = useCallback((event: MessageEvent) => {
    if (event.data.action === TPrintButtonAction.PrintPageLoaded) {
      setIsLoading(false);
      window.removeEventListener('message', handleMessage);
    }
  }, []);

  const printPage = useCallback(() => {
    if (onClick) return onClick();

    const iframe = document.getElementById('print-page') as HTMLIFrameElement;
    const iframeWindow = iframe?.contentWindow;

    iframe.focus();
    iframeWindow?.print();

    return false;
  }, [onClick]);

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);

  return (
    <>
      {!disableIframe && (
        <iframe id="print-page" src={linkToPrintPage} style={{ display: 'none' }} title="Print" />
      )}

      <Button
        variant="text"
        href=""
        className={cn('print-btn no-print-and-hide', className)}
        disabled={isLoading}
        onClick={printPage}
      >
        {isLoading ? (
          <CircularProgress
            className="print-btn__action-loader"
            color="inherit"
            size={16}
            thickness={5}
          />
        ) : (
          <PrintIcon color="success" />
        )}

        <span className="print-btn__button_text">{buttonText}</span>
      </Button>
    </>
  );
};

export default PrintButton;
